import React, { useRef } from 'react';

const DemographicsForm: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const handleClear = () => formRef.current?.reset();

  return (
    <form ref={formRef} className="form-grid">
      <div className="field">
        <label>Date Completed</label>
        <input type="date" />
      </div>
      <div className="field">
        <label>Date of Birth</label>
        <input type="date" />
      </div>

      <div className="field col-span-2">
        <label>Baby's Name</label>
        <input type="text" placeholder="Enter baby's full name" />
      </div>

      <div className="section-title col-span-2">Contact Information for Parent 1</div>
      <div className="field">
        <label>Name</label>
        <input type="text" />
      </div>
      <div className="field">
        <label>Email</label>
        <input type="email" />
      </div>
      <div className="field">
        <label>Home Address</label>
        <input type="text" />
      </div>
      <div className="field">
        <label>Home Phone</label>
        <input type="tel" />
      </div>
      <div className="field">
        <label>Work Phone</label>
        <input type="tel" />
      </div>
      <div className="field">
        <label>Cell / Other</label>
        <input type="tel" />
      </div>

      <div className="section-title col-span-2">Contact Information for Parent 2</div>
      <div className="field">
        <label>Name</label>
        <input type="text" />
      </div>
      <div className="field">
        <label>Email</label>
        <input type="email" />
      </div>
      <div className="field">
        <label>Home Address</label>
        <input type="text" />
      </div>
      <div className="field">
        <label>Home Phone</label>
        <input type="tel" />
      </div>
      <div className="field">
        <label>Work Phone</label>
        <input type="tel" />
      </div>
      <div className="field">
        <label>Cell / Other</label>
        <input type="tel" />
      </div>

      <div className="section-title col-span-2">The baby lives with:</div>
      <div className="field col-span-2">
        <select>
          <option value="">Click here to choose</option>
          <option>Both Parents</option>
          <option>Mother</option>
          <option>Father</option>
          <option>Guardian(s)</option>
          <option>Other</option>
        </select>
      </div>
      <div className="form-actions col-span-2">
        <button type="button" className="btn-clear" onClick={handleClear}>Clear</button>
      </div>
    </form>
  );
};

export default DemographicsForm;


